import { legalFormValueType } from '@/constants/legalForm';
import { valueType } from '@/constants/diagnosis';

export const getValueType = (list, type) => {
  if (!list || !list.length) return [];
  let _valueType = null;
  return list.map(item => {
    if (type == 'diagnosis') {
      _valueType = valueType.get(item.type);
    } else {
      _valueType = legalFormValueType.get(item.type);
    }
    return {
      ...item,
      valueType: _valueType,
    };
  });
};
export const getDignosisData = type => {
  const typeMep = new Map([
    ['diagnosis', 'diagnosisFormData'],
    ['leagalForm', 'leagalFormData'],
  ]);
  let list = [];
  const data = localStorage.getItem(typeMep.get(type));
  const isEnd = localStorage.getItem(`${typeMep.get(type)}IsEnd`);
  if (data && isEnd === 'true') {
    list = getValueType(JSON.parse(data), type);
  }
  return list;
};

export function isMobile() {
  if (/(ipad|iphone|ipod|android|mobile)/i.test(navigator.userAgent)) {
    return true;
  }
  return false;
}

export const isMobileView = () => {
  return window.innerWidth < 968;
};

// 写一个将数字中的小数点替换成逗号的函数
export function formatNumber(num) {
  if (!num) return '';
  // 如何num没有小数点，则自动添加小数点并补充两个0
  if (num.toString().indexOf('.') === -1) {
    return num.toString() + ',00';
  }
  return num.toString().replace('.', ',');
}

// 数字千分位使用空格隔开、遇到小数点.替换成英文的逗号,
export function formatNumberWithSpaceAndComma(num) {
  if (num == null || num == '' || num == 0) return 0;
  return num
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    .replace('.', ',');
}
